import { useMemo } from 'react';

import {
	CONVERSATION_ASSISTANT_CONTAINER_ID,
	CONVERSATION_ASSISTANT_CONTAINER_WIDTH,
} from '@atlassian/conversation-assistant/constants';
import type { RovoExperienceSidebarAPI } from '@atlassian/rovo-experience-api/rovo-experience-api-store';

import { useRightSidebarContext } from '@confluence/page-layout-context';

/**
 * Creates a controller for managing the Rovo Experience sidebar panel state
 * @returns {RovoExperienceSidebarAPI} An object with methods to manage the sidebar panel
 **/
export const useCreateRovoExperienceSidebarController = (): RovoExperienceSidebarAPI => {
	const rightSidebarContext = useRightSidebarContext();
	const { panelId } = rightSidebarContext.getCurrent() || {};
	const isConversationAssistantSidebarActive = panelId === CONVERSATION_ASSISTANT_CONTAINER_ID;

	return useMemo(() => {
		return {
			isSidebarOpen: () => {
				return isConversationAssistantSidebarActive;
			},
			openSidebar: () => {
				rightSidebarContext.open(
					CONVERSATION_ASSISTANT_CONTAINER_ID,
					CONVERSATION_ASSISTANT_CONTAINER_WIDTH,
				);
			},
			closeSidebar: () => {
				if (isConversationAssistantSidebarActive) {
					rightSidebarContext.close(CONVERSATION_ASSISTANT_CONTAINER_ID);
				}
			},
		};
	}, [isConversationAssistantSidebarActive, rightSidebarContext]);
};
